// src/services/produtos/ImagemService.js
import { fetchFileData } from '../Api';

export const obterArquivoImagemProduto = (produtoId) => fetchFileData(
    '/ProdutoDelivery/ProdutoImagemArquivo',
    { produtoId },
);

export const obterArquivoImagemGrupo = (grupoId) => fetchFileData(
    '/GrupoDelivery/GrupoImagemArquivo',
    { grupoId },
);
